import styled from 'styled-components';

export const VsTraditional = styled.section`
  color: white;
  overflow-x: scroll;
  padding: 20px;
  ${props => props.theme.media.lg} {
    background-color: #3F5261;
    max-width: 1128px;
    margin: auto;
    border-radius: 50px;
  }

  .container {
    h2 {
      color: white;
      
      .title-us {
        font-size: 34px;
        font-weight: 450;

        ${props => props.theme.media.lg} {
          font-weight: 400;
        }
      }

      .title-vs {
        display: inline-block;
        position: relative;
        border-bottom: 4px solid white;
        line-height: 1;
        bottom: .5rem;
        font-size: 26px;

        ${props => props.theme.media.lg} {
          font-size: 30px;
          line-height: .9;
          bottom: .25rem;
          border-bottom: 4px solid white;
        }
      }

      .title-them {
        font-size: 23px;
        font-weight: 450;

        ${props => props.theme.media.lg} {
          font-size: 30px;
          font-weight: 400;
        }
      }

    }
  }

  .vs-traditional {
    min-width: 800px;
    background-color: #3F5261;
    border-radius: 50px;
    .col-lg {
      ${props => props.theme.media.lg} {
        padding: 0;
      }
    }
   
    .vs-item {
      border-radius: 5px;
      margin: 15px 0;

      .header {
        border-bottom: 1px solid white;
        text-align: center;
        padding-bottom: 20px;
      }

      ul {
        padding: 0px 0px;
        list-style: none;

        li:last-child {
          border: none;
        }
        ${props => props.theme.media.lg} {
          padding: 0;
        }
      }

      li {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 0 1.125rem;
        font-weight: 350;
        height: 36px;
        line-height: 1.3;
        strong, b {
          font-weight: 700;
        }

        ${props => props.theme.media.lg} {
          height: 100%;
          margin: 0;
        }
      }

      .list-content {
        position: relative;
        text-align: left;
        border-radius: 25px;
        margin-top: 1rem;

        li {
          position: relative;
          font-family: Poppins;
          font-size: 18px;
          border-bottom: 1px solid white;

          ${props => props.theme.media.lg} {
            border-bottom: 1px solid white;
          }
        }

        p {
          ${props => props.theme.media.lg} {
            line-height: inherit;
          }
        }
      }

      &.us {
        p {
          font-size: 26px;
          font-family: Poppins;
          font-weight: 450;
          text-align: center;
          margin-bottom: 0;
          height: 200px;
          ${props => props.theme.media.lg} {
            height: 200px;
            // margin-bottom: 30px;
          }
        }
        img {
          display: block;
          width: 130px;
          margin: 0 auto 10px;

          ${props => props.theme.media.lg} {
            // margin-bottom: 10px;
            // margin-top: -20px
          }
        }

        .header {
          border-radius: 25px;
          padding: 1.5rem 1rem;
        }

        .list-content {
          text-align: center;
          border-radius: 25px;
          margin-top: 1rem;
        }
      }

      &.them {
        border-color: ${props => props.theme.gray500};
        height: 200px;
        .header {
          position: relative;
          font-size: 1.5rem;
          font-weight: bold;
          line-height: 40px;
          padding: 1.5rem 1rem;
        }

        p {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 250px;
          margin: auto;
          line-height: 1;
          font-size: 26px;
          font-family: Poppins;
          text-align: center;

          img {
            margin-bottom: 10px;
          }
          ${props => props.theme.media.lg} {
            height: 200px;
          }
        }

        .list-content {
          text-align: center;
          font-size: 26px;
          font-family: Poppins;
          font-weight: 450px;

          img {
            width: 119px;
            margin-bottom: 20px;
          }
        }

        .list-content > p {
          padding-bottom: 10px;

          ${props => props.theme.media.lg} {
            padding-bottom: 0px;
          }
        }
      }
    }
  }

  .col-lg:first-child {
    border-right: 1px solid white;
    margin: 20px 0;
    ${props => props.theme.media.lg} {
      border-right: 1px solid white;
      padding-left: 7rem;

      li {
        padding-top: 1.5rem;
      }
    }
  }

  .col-lg:last-child {
     margin: 20px 0;
    ${props => props.theme.media.lg} {
      padding-right: 7rem;

      li {
        padding-top: 1.5rem;
      }
    }

  }

  .anyone {
    margin-top: 20px;

    p {
      font-size: 14px;
      font-family: Inter;
      text-align: center;
      line-height: 24px;
      max-width: 370px;
      width: 100%;
      margin: auto;

      ${props => props.theme.media.lg} {
        margin: auto;
        width: 100%;
        max-width: 625px;
        text-align: left;
        font-size: 16px;
        font-weight: 350;
      }
    }
  }
  .icons-with-text {
    text-align: center;
    margin: 40px 0 0;
    text-transform: uppercase;
    font-weight: 500;
    .item {
      margin: 30px 0 0;
      ${props => props.theme.media.md} {
        margin: 0;
      }
    }
    .icon {
      margin-bottom: 20px;
    }
  }

  .row{
    flex-wrap: nowrap;
  }
`;
